import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"
import { GridDialog } from ".."
import { FormattedMessage } from "react-intl"

const useStyles = makeStyles(theme => ({
  body: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(8, 0),
  },
  content: {
    width: "100%",
    maxWidth: theme.spacing(60),
    height: theme.spacing(45),
    margin: "auto",
  },
  title: {
    color: theme.palette.black.main,
    textAlign: "center",
    margin: "auto",
  },
  bodyText: {
    textAlign: "center",
    marginBottom: theme.spacing(4),
    maxWidth: theme.spacing(45),
    margin: "auto",
  },
  leafLeft: {
    position: "absolute",
    left: 0,
    top: "10%",
    width: 80,
    height: 77,
    zIndex: 2,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  leafRight: {
    position: "absolute",
    right: 0,
    bottom: "10%",
    width: 80,
    height: 77,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },

  payUText: {
    color: "#B7D100",
  },
  payULogo: {
    margin: theme.spacing(8, 0, 2, 0),
    position: "relative",
    left: "50%",
    transform: "translate(-50%)",
    height: theme.spacing(8),
  },
}))

const PayURedirectModal = props => {
  const classes = useStyles()
  return (
    <GridDialog fullScreen={"sm"} xs={8} open={props.open}>
      <div className={classes.body}>
        <img src={props.bgImgLeft} className={classes.leafLeft} alt={""} />
        <img src={props.bgImgRight} className={classes.leafRight} alt={""} />
        <div className={classes.content}>
          <img src={props.payULogo} className={classes.payULogo} alt={""} />

          <Typography
            id={props.titleId}
            variant={"h4"}
            classes={{ root: classes.title }}
          >
            <FormattedMessage id="redictingToPayU" />
          </Typography>

          <Typography classes={{ root: classes.bodyText }} variant={"body1"}>
            <FormattedMessage id="youAreBeingRedirected1" />
            <b className={classes.payUText}> PayU </b>
            <FormattedMessage id="youAreBeingRedirected2" />
          </Typography>
        </div>
      </div>
    </GridDialog>
  )
}

export default PayURedirectModal
